module.exports = __webpack_public_path__ + "img/mobile-sidebar.95b83a5a.svg";